import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getMediumPublicProfileDetails } from "../../services/uidata";
import "./embeded.css";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setLoading } from "../../reducer/auth/auth";

export default function Embeded() {
    const params = useParams();
    const { t } = useTranslation("components");
    const [personal_booking_links, setpersonal_booking_links] = useState('');
    const [medium_id, setMediumId] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setLoading(true))
        getMediumPublicProfileDetails(params.id).then((data) => {
            console.log(data.data.data)
            dispatch(setLoading(false))
            if (data.data.status) {
                setpersonal_booking_links(data.data.data.general.personal_booking_link)
                setMediumId(data.data.data.general.medium_id);
            }
        }).catch(() => {
            dispatch(setLoading(false))
         })
    }, []);
    return (
       <div className="embeded-wrapper">
            <div className="embeded-container">
                <div className="embeded-btn-container">
                    <a
                        target="_blank"
                        className="btn1"
                        href={`${process.env.REACT_APP_BASE_URL}profile-view/${params.id}`}
                        rel="noreferrer"
                    >
                        {t("embed.recentReviews")}
                    </a>

                    {/* {medium_id != 329 ? ( */}
                        <a
                            target={"_blank"}
                            href={`${process.env.REACT_APP_BASE_URL}guest-booking/${medium_id}`}
                            className="btn2"
                            rel="noreferrer"
                        >
                            {t("embed.bookNow")}
                        </a>
                    {/* ) : (
                        <div className="status-message-container">
                            <p className="booking-note">
                                Tammy is not currently taking any new bookings due to a personal emergency. 
                                <span>Please check back in a few days for potential availability.</span>
                            </p>
                        </div>
                    {/* )} */}
                </div>

                <div className="embeded-powered-container">
                    <span>{t("embed.poweredBy")}</span>
                    <img src="/localImages/powered.png" alt="" /> <span>VerySoul</span>
                </div>
            </div>
        </div>
    );
}
